<template>
  <div class="chart-container w-100">
    <apexchart type="bar" :height="chartHeight" width="100%" :options="chartOptions" :series="series"/>
  </div>
</template>

<script>
export default {
  name: 'HeadcountDepartmentsChart',
  props: {
    chartSeries: {
      type: Array,
      required: true
    },
    chartHeight: {
      type: [Number, String],
      default: 400
    },
    companyPrimaryColor: {
      type: String,
      default: '#006859'
    }
  },
  computed: {
    sortedData() {
      return [...this.chartSeries].sort((a, b) => b.headcount - a.headcount) 
    },
    series() {
      return [{
        name: 'Headcount',
        data: this.sortedData.map(item => item.count)
      }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'Manrope, Arial, sans-serif'
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },      
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val || ''
          },
          style: {            
            colors: ['#fff']
          }
        },
        yaxis: {          
          labels: {
            style: {
              fontWeight: 400
            }
          }          
        },        
        xaxis: {
          categories: this.sortedData.map(item => item.category),
          labels: {
            style: {
              fontWeight: 400
            }
          }      
        },
        colors: [this.companyPrimaryColor]
      }
    }
  }
}
</script>